<template>
  <div class="input-line-multiplier">
    <div class="input-line-multiplier--inputwrap">
      <GekkoButton
        @click="substractQuantity"
        :disabled="line_multiplier <=0"
        :icon="'fa-solid fa-minus'"
        variant="light"
        class="invoice-line-multiplier-btn text-brand"
        size="sm"
      />
      <b-input-group>
        <b-form-input type="number" placeholder="0.00" step="any" v-model.number="line_multiplier" required @input="$emit('compute-net-value')" :disabled="isDisabled" />
      </b-input-group>
      <GekkoButton
        @click="increaseQuantity"
        :icon="'fa-solid fa-plus'"
        variant="light"
        class="invoice-line-multiplier-btn text-brand"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import GekkoButton from "@/components/GekkoButton";

export default {
  name: "LineQuantityInput",
  components: {
    GekkoButton
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      productList: [],
      selectedIndex: -1,
      enableSearch: false,
      showProductModal: false,
      scrollBarsOptions: {
        scrollbars: { autoHide: 'never' },
        overflowBehavior: { y: 'scroll', x: 'hidden' },
        callbacks : {
            onScroll: this.handleScroll
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: "main/getCurrentCompany",
      productGroups: "invoices/getProductGroups"
    }),
    line_multiplier: {
      get () { return this.value },
      set (line_multiplier) { this.$emit('input', line_multiplier)  }
    },
  },
  created () {

  },
  methods: {
    parseMultiplier (line_multiplier) {
      let parsed_multiplier
      if (line_multiplier * 100 % 1 !== 0) {
        // If the remainder is not zero, the number has more than two decimals
        parsed_multiplier = parseFloat(line_multiplier).toFixed(2)
      } else {
        parsed_multiplier = line_multiplier
      }
      return parsed_multiplier.toString()
    },
    substractQuantity () {
      if (this.line_multiplier >= 1) {
        this.line_multiplier = (parseFloat(this.line_multiplier) - 1).toFixed(2)
      } else {
        this.line_multiplier = 0
      }
      this.$emit('compute-net-value')
    },
    increaseQuantity () {
      this.line_multiplier = (parseFloat(this.line_multiplier) + 1).toFixed(2)
      this.$emit('compute-net-value')
    }
  }
}
</script>

<style lang="scss">

</style>
<style lang="scss" scoped>
.input-line-multiplier {
  display: flex;
  align-items: center;
  &--inputwrap {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }
  .input-group-prepend {
    .invoice-line-multiplier-inputbtn {
      border-top-left-radius: $radiusMd;
      border-bottom-left-radius: $radiusMd;
    }
  }
  .input-group-append {
    .invoice-line-multiplier-inputbtn {
      border-top-right-radius: $radiusMd;
      border-bottom-right-radius: $radiusMd;
    }
  }

  .form-control,
  .invoice-line-multiplier-inputbtn {
    padding: 0.25rem 0.5rem;
  }

  .invoice-line-multiplier-inputbtn {
    font-size: 14px;
    border-left: 0px;
    color: $colorBlue;
    box-shadow: $inputBoxShadow !important;

    border: 0px;
    box-shadow: $inputBoxShadow !important;
    background-color: $inputBackgroundColor;

    &:hover, &:active, &:focus {
      background-color: $inputBackgroundColor !important;
      border-color: $inputBorderColor !important;
      color: $colorBlue !important;
      opacity: 1;
    }
    &.btn.disabled {
      box-shadow: $inputBoxShadow !important;
      background-color: $inputBackgroundColor;
      color: $colorTextLight !important;
      opacity: 1 !important;
    }
  }

  .invoice-line-multiplier-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    height: 24px;
    width: 24px;
    border-radius: 100px;
    padding: 0;
    font-size: 12px;
  }

}
</style>